'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes, Children } = React;

require('./AboutSection.less');

var AboutSection = React.createClass({
  mixins: [ClassNameMixin,  PureRenderMixin],

  propTypes: {
    layout: PropTypes.oneOf(['full', 'section', 'banner']).isRequired,
    active: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    showLogo: PropTypes.bool,
    footer: PropTypes.element,
    color: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
    backgroundImage: PropTypes.string,
    needsTopMarginOnTablet: PropTypes.bool
  },

  getDefaultProps() {
    return {
      active: true,
      showLogo: false
    };
  },

  getCSSModifiers() {
    const { layout, needsTopMarginOnTablet, active } = this.props;

    return {
      [layout]: true,
      needsTopMarginOnTablet,
      inactive: !active
    };
  },

  render: function () {
    return (
      <div className={this.getClassName()}
           style={{
             color: this.props.color,
             backgroundColor: this.props.backgroundColor,
             backgroundImage: this.props.backgroundImage,
             backgroundSize: 'cover',
             backgroundPosition: 'center'
           }}>
        {this.props.layout === 'full' ?
          this.props.children :
          this.renderSection()
        }
      </div>
    );
  },

  renderSection() {
    var { title, subtitle, children, showLogo } = this.props,
        hasChildren = Children.count(children) > 0;

    return [
      <div className='AboutSection-header' key='header'>
        {showLogo &&
          <h1 className='AboutSection-logo'>Stampsy</h1>
        }
        <h2 className='AboutSection-title'>{title}</h2>
        {subtitle &&
          <h3 className='AboutSection-subtitle'>{subtitle}</h3>
        }
      </div>,

      hasChildren && (
        <div className='AboutSection-extra' key='extra'>
          {children}
        </div>
      ),

      this.props.footer && (
        <div className='AboutSection-footer' key='footer'>
          {this.props.footer}
        </div>
      )
    ];
  }
});

module.exports = AboutSection;



/** WEBPACK FOOTER **
 ** ./organisms/AboutSection.jsx
 **/